import { makeStyles } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  actionButtons: {
    display: 'flex'
  },
  avatarList: {
    marginTop: theme.spacing(1)
  },
  editIcon: {
    padding: theme.spacing(0, 1)
  }
}));

export const useTitleDetailsStyles = makeStyles(theme => ({
  historyLogButton: {
    marginLeft: theme.spacing(1)
  },
  infoText: {
    marginLeft: theme.spacing(0.5)
  },
  privacyIcon: {
    marginRight: theme.spacing(1),
    alignSelf: 'center'
  },
  detailsContainer: {
    marginLeft: theme.spacing(6.5)
  }
}));

export const AlertContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));
